/**
 * Merkezi bildirim servisi – WebSocket mesajlarını type bazlı dağıtır.
 * Yeni bildirim tipi eklemek: registerNotificationHandler('MY_TYPE', handler)
 */

const handlers = new Map();
const globalListeners = new Set();

export function registerNotificationHandler(type, handler) {
  if (!type || typeof handler !== 'function') return () => {};
  handlers.set(String(type).toUpperCase(), handler);
  return () => handlers.delete(String(type).toUpperCase());
}

export function subscribeNotifications(listener) {
  if (typeof listener !== 'function') return () => {};
  globalListeners.add(listener);
  return () => globalListeners.delete(listener);
}

function dispatch(notification) {
  if (!notification || typeof notification !== 'object') return;
  const type = String(notification.type || '').toUpperCase();
  for (const fn of globalListeners) {
    try { fn(notification); } catch (_) { /* ignore */ }
  }
  const handler = handlers.get(type);
  if (handler) {
    try { handler(notification); } catch (_) { /* ignore */ }
  }
  window.dispatchEvent(new CustomEvent('app-notification', { detail: notification }));
}

export function handleIncomingNotification(raw) {
  dispatch(raw);
}

export function initNotificationService() {
  return subscribeNotifications((n) => {
    if (n?.type === 'CARI_ASSIGNMENT_BADGE') {
      window.dispatchEvent(new CustomEvent('cari-atama-bildirim-ws', { detail: n }));
    }
    if (n?.type === 'CARI_ILGI_BADGE') {
      window.dispatchEvent(new CustomEvent('cari-ilgi-bildirim-ws', { detail: n }));
    }
  });
}
